import {
    ClientKpiConfiguration,
    KpiDefinition,
    KpiFilters,
    KpiResult,
} from './types';
import ApiService from 'services/apiService';

const definitions: KpiDefinition[] = [
    { id: 'totalParticipantsServed', key: 'totalParticipantsServed', label: 'Total Participants Served', format: 'number', defaultOrder: 1 },
    { id: 'totalServicesDelivered', key: 'totalServicesDelivered', label: 'Total Services Delivered', format: 'number', defaultOrder: 2 },
    { id: 'totalHoursDelivered', key: 'totalHoursDelivered', label: 'Total Hours Delivered', format: 'decimal', defaultOrder: 3 },
    { id: 'averageHoursPerParticipant', key: 'averageHoursPerParticipant', label: 'Average Hours per Participant', format: 'decimal', defaultOrder: 4 },
    { id: 'averageSessionsPerParticipant', key: 'averageSessionsPerParticipant', label: 'Average Sessions per Participant', format: 'decimal', defaultOrder: 5 },
    { id: 'participantsWithoutServices', key: 'participantsWithoutServices', label: 'Participants Without Services', format: 'number', defaultOrder: 6 },
];

const configurationByTab = new Map<string, ClientKpiConfiguration[]>();

const getDefaultConfiguration = (dashboardTabId: string): ClientKpiConfiguration[] =>
    definitions.flatMap((definition) => (['student', 'parent'] as const).map((viewType, audienceIndex) => ({
        dashboardTabId,
        kpiId: definition.id,
        viewType,
        enabled: viewType === 'student',
        displayOrder: (definition.defaultOrder * 2) - 1 + audienceIndex,
    })));

export class KpiService {
    static async getAvailableKpis(): Promise<KpiDefinition[]> {
        return definitions.map((definition) => ({ ...definition }));
    }

    static async getClientKpiConfiguration(dashboardTabId: string): Promise<ClientKpiConfiguration[]> {
        const configuration = configurationByTab.get(dashboardTabId) ?? getDefaultConfiguration(dashboardTabId);
        if (!configurationByTab.has(dashboardTabId)) configurationByTab.set(dashboardTabId, configuration);
        return configuration.map((item) => ({ ...item }));
    }

    static async getKpiResults(filters: KpiFilters): Promise<KpiResult[]> {
        const response = await ApiService.instance.get<{ results: KpiResult[] }>(
            '/KpiDashboard/GetKpiResults',
            { params: { schoolYear: filters.schoolYearId, programId: filters.programId } },
        );

        if (response.status !== 200 || !Array.isArray(response.data?.results)) {
            throw new Error('Failed to load KPI results.');
        }

        return response.data.results;
    }

    static async saveClientKpiConfiguration(configuration: ClientKpiConfiguration[]): Promise<void> {
        const dashboardTabId = configuration[0]?.dashboardTabId;
        if (dashboardTabId) configurationByTab.set(dashboardTabId, configuration.map((item) => ({ ...item })));
    }
}
